import { SplixerNestResourceInterface } from './splixer-resource.interface';
import { FieldConfig, FieldDataTypes, uNumber } from '@hidat/huijs-common';
import { HasTenantResource, ResourceConfig } from '@hidat/huijs-resource';
import {
  splixerFieldConfigs,
  splixerSystemFields,
} from './splixer-fields.const';

export const MixShowItemConfig: ResourceConfig = new ResourceConfig(
  'MixShowItem',
  'mix_show_items',
)
  .addFields([
    splixerFieldConfigs.showId,
    splixerFieldConfigs.mixId,
    new FieldConfig('seqNum', FieldDataTypes.INTEGER),
    splixerFieldConfigs.status,
    ...splixerSystemFields,
  ])
  .setSorts({
    seqNum: 'seqNum',
  })
  .setDefaultSort('seqNum');

export interface MixShowItemInterface
  extends SplixerNestResourceInterface, HasTenantResource {
  mixId: uNumber;
  showId: uNumber;
  seqNum: uNumber;
}
